import { GlobalResponseObject } from '../../../common';
import { BroadcastSummaryModel } from './broadcast-summary.model';

export class BroadcastSummaryResponse extends GlobalResponseObject {
    data?: BroadcastSummaryModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: BroadcastSummaryModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}